import styled from 'styled-components';
import { Layout } from 'src/components/Layout';

export const LayoutStyled = styled(Layout)`
    background-color: silver;
`;

export const FormWrapperStyled = styled.div`
    height: 76vh;
    padding-top: 150px;
`
